import { createContext } from 'react'

// Começa de 10 porque os fixos já vão até 9
export const defaultMapSequence = 10 // Número sequencial dos containers de mapa. Nunca deixar repetir, para evitar o erro: "Unhandled Rejection (Error): Map container is being reused by another instance"
                                  
const MapSequenceContext = createContext({mapSequence:defaultMapSequence, setMapSequence: () => {}}) 

export default MapSequenceContext